import { render, staticRenderFns } from "./updateStory.vue?vue&type=template&id=6a862368&scoped=true"
import script from "./updateStory.vue?vue&type=script&lang=js"
export * from "./updateStory.vue?vue&type=script&lang=js"
import style0 from "./updateStory.vue?vue&type=style&index=0&id=6a862368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a862368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a862368')) {
      api.createRecord('6a862368', component.options)
    } else {
      api.reload('6a862368', component.options)
    }
    module.hot.accept("./updateStory.vue?vue&type=template&id=6a862368&scoped=true", function () {
      api.rerender('6a862368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/updateStory.vue"
export default component.exports